"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2898],{

/***/ 19536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_buildProduct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88985);


var addToCart = function addToCart() {
  var _window, _window$kwaiq;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    product = _ref.product;
  var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;
  var kwaiId = publicRuntimeConfig.kwaiId;
  if (((_window = window) == null ? void 0 : (_window$kwaiq = _window.kwaiq) == null ? void 0 : _window$kwaiq.instance) && kwaiId && product) {
    window.kwaiq.instance(kwaiId).track('addToCart', (0,_utils_buildProduct__WEBPACK_IMPORTED_MODULE_1__["default"])(product));
  }
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 77981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19536);
/* harmony import */ var _pageView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9327);


var events = {
  'addtocart:success': [_addToCart__WEBPACK_IMPORTED_MODULE_0__["default"]],
  pageview: [_pageView__WEBPACK_IMPORTED_MODULE_1__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 9327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_buildProduct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88985);


var pageView = function pageView() {
  var _window, _window$kwaiq;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$data = _ref.data,
    _ref$data2 = _ref$data === void 0 ? {} : _ref$data,
    product = _ref$data2.product,
    structure = _ref.structure;
  var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;
  var kwaiId = publicRuntimeConfig.kwaiId;
  if (!((_window = window) == null ? void 0 : (_window$kwaiq = _window.kwaiq) == null ? void 0 : _window$kwaiq.instance) || !kwaiId) return;
  if ((structure == null ? void 0 : structure.id) === 'product') {
    window.kwaiq.instance(kwaiId).track('contentView', (0,_utils_buildProduct__WEBPACK_IMPORTED_MODULE_1__["default"])(product));
  } else {
    window.kwaiq.instance(kwaiId).track('contentView');
  }
};
/* harmony default export */ __webpack_exports__["default"] = (pageView);

/***/ }),

/***/ 40649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77981);


/***/ }),

/***/ 88985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var buildProduct = function buildProduct(product) {
  var _product$category, _product$subcategory, _product$price, _product$price2, _product$price3, _product$price4;
  return {
    content_category: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.id), " - ").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(product == null ? void 0 : (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.id)),
    content_id: product == null ? void 0 : product.variationId,
    content_name: product == null ? void 0 : product.title,
    content_type: 'product',
    currency: 'BRL',
    price: (product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.bestPrice) || (product == null ? void 0 : (_product$price2 = product.price) == null ? void 0 : _product$price2.price),
    quantity: 1,
    value: (product == null ? void 0 : (_product$price3 = product.price) == null ? void 0 : _product$price3.bestPrice) || (product == null ? void 0 : (_product$price4 = product.price) == null ? void 0 : _product$price4.price)
  };
};
/* harmony default export */ __webpack_exports__["default"] = (buildProduct);

/***/ }),

/***/ 65635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _hooks_useSdkLogin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16468);

var events = {
  'question:miniapp:open:float:modal': [_hooks_useSdkLogin__WEBPACK_IMPORTED_MODULE_0__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 16468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86522);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34795);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6422);


function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }

var useSdkLogin = function () {
  var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_regeneratorRuntime().mark(function _callee() {
    var _ref2,
      structure,
      logger,
      logged,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, structure = _ref2.structure;
          logger = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Yd)((structure == null ? void 0 : structure.config) || {});
          _context.next = 4;
          return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .useCheckUserCredentials */ .tI)(logger);
        case 4:
          logged = _context.sent;
          if (logged) {
            _context.next = 15;
            break;
          }
          _context.prev = 6;
          _context.next = 9;
          return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .useRequestUserCredential */ .uY)(logger);
        case 9:
          return _context.abrupt("return", _context.sent);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](6);
          return _context.abrupt("return", {});
        case 15:
          return _context.abrupt("return", null);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 12]]);
  }));
  return function useSdkLogin() {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ __webpack_exports__["default"] = (useSdkLogin);

/***/ }),

/***/ 10379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65635);


/***/ }),

/***/ 3703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86522);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34795);


function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var giveActionPoints = function () {
  var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_regeneratorRuntime().mark(function _callee(_ref) {
    var _config$parceiromagal, _config$parceiromagal2;
    var config, profilesActionsUrl, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = _ref.config;
          profilesActionsUrl = config == null ? void 0 : (_config$parceiromagal = config.parceiromagalu) == null ? void 0 : (_config$parceiromagal2 = _config$parceiromagal.rochelle) == null ? void 0 : _config$parceiromagal2['profile-actions'];
          _context.prev = 2;
          _context.next = 5;
          return fetch(profilesActionsUrl, {
            method: 'POST'
          });
        case 5:
          response = _context.sent;
          if (response.ok) {
            _context.next = 8;
            break;
          }
          throw new Error("actionPoints request failed for ".concat(profilesActionsUrl, " with status: ").concat(response.status, " ").concat(response.statusText));
        case 8:
          return _context.abrupt("return", {});
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          console.error("[Events - actionPoints] - error: ".concat(_context.t0));
          return _context.abrupt("return", []);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 11]]);
  }));
  return function giveActionPoints(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/* harmony default export */ __webpack_exports__["default"] = (giveActionPoints);

/***/ }),

/***/ 41234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _giveActionPoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3703);

var PmdActions = {
  'facebook:socialshare:click': [_giveActionPoints__WEBPACK_IMPORTED_MODULE_0__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (PmdActions);

/***/ }),

/***/ 99141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _normalizeStoreName__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58373);


var ML2_SID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.ML2_SID */ .VD.ML2_SID;
var addToCart = function addToCart(_ref, _ref2, config) {
  var _structure$route, _structure$config, _structure$config2;
  var cartId = _ref.cartId;
  var structure = _ref2.structure;
  var storeId = structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.storeId;
  var normalizedStoreName = (0,_normalizeStoreName__WEBPACK_IMPORTED_MODULE_1__["default"])(storeId, config == null ? void 0 : config.prefix);
  var cartIdCookie = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ML2_SID);
  var storeCartId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)("".concat(ML2_SID, "_").concat(normalizedStoreName));
  if (storeCartId === cartId && cartIdCookie === cartId) return;
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
    domain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
    name: ML2_SID,
    value: cartId
  });
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
    domain: structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.cookieDomain,
    name: "".concat(ML2_SID, "_").concat(normalizedStoreName),
    value: cartId
  });
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 63684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _pmdCookieCheckout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58996);

var buyButtonsClick = function buyButtonsClick(props) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref.structure;
  (0,_pmdCookieCheckout__WEBPACK_IMPORTED_MODULE_0__["default"])({
    structure: structure
  });
};
/* harmony default export */ __webpack_exports__["default"] = (buyButtonsClick);

/***/ }),

/***/ 86823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _pmdCookieCheckout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58996);
/* harmony import */ var _buyButtonsClick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63684);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99141);



var events = {
  'addtocart:success': [_addToCart__WEBPACK_IMPORTED_MODULE_2__["default"]],
  'buybuttons:click': [_buyButtonsClick__WEBPACK_IMPORTED_MODULE_1__["default"]],
  pageview: [_pmdCookieCheckout__WEBPACK_IMPORTED_MODULE_0__["default"]],
  'shoppingbag:click': [_pmdCookieCheckout__WEBPACK_IMPORTED_MODULE_0__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 58373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var normalizeStoreName = function normalizeStoreName() {
  var storeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'magazine';
  return (storeName == null ? void 0 : storeName.startsWith(prefix)) ? storeName : "".concat(prefix).concat(storeName);
};
/* harmony default export */ __webpack_exports__["default"] = (normalizeStoreName);

/***/ }),

/***/ 58996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _normalizeStoreName__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58373);


var ML2_SID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.ML2_SID */ .VD.ML2_SID;
var pmdCookieCheckout = function pmdCookieCheckout(_ref, config) {
  var _structure$route, _structure$config, _config$partnerId, _structure$config2, _structure$config4;
  var structure = _ref.structure;
  var storeId = structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.storeId;
  var normalizedStoreName = (0,_normalizeStoreName__WEBPACK_IMPORTED_MODULE_1__["default"])(storeId, config == null ? void 0 : config.prefix);
  var cartId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ML2_SID);
  var storeCartId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)("".concat(ML2_SID, "_").concat(normalizedStoreName));
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
    domain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
    name: 'MLPARCEIRO',
    value: (_config$partnerId = config == null ? void 0 : config.partnerId) !== null && _config$partnerId !== void 0 ? _config$partnerId : 3440
  });
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
    domain: structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.cookieDomain,
    name: (config == null ? void 0 : config.cookieShowcaseName) || 'mvc_showcase_name',
    value: normalizedStoreName
  });
  if (storeCartId === cartId) return;
  if (storeCartId) {
    var _structure$config3;
    (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
      domain: structure == null ? void 0 : (_structure$config3 = structure.config) == null ? void 0 : _structure$config3.cookieDomain,
      name: ML2_SID,
      value: storeCartId
    });
    return;
  }
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .removeCookie */ .nJ)(ML2_SID, structure == null ? void 0 : (_structure$config4 = structure.config) == null ? void 0 : _structure$config4.cookieDomain, '/');
};
/* harmony default export */ __webpack_exports__["default"] = (pmdCookieCheckout);

/***/ }),

/***/ 3433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _PmdCartCookie_addToCart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99141);

var addToCart = function addToCart(cart, settings) {
  (0,_PmdCartCookie_addToCart__WEBPACK_IMPORTED_MODULE_0__["default"])(cart, settings, {
    prefix: 'parceiro'
  });
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 29805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _pmeCookieCheckout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59765);

var buyButtonsClick = function buyButtonsClick(props) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref.structure;
  (0,_pmeCookieCheckout__WEBPACK_IMPORTED_MODULE_0__["default"])({
    structure: structure
  });
};
/* harmony default export */ __webpack_exports__["default"] = (buyButtonsClick);

/***/ }),

/***/ 58579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _pmeCookieCheckout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59765);
/* harmony import */ var _buyButtonsClick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29805);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3433);



var events = {
  'addtocart:success': [_addToCart__WEBPACK_IMPORTED_MODULE_2__["default"]],
  'buybuttons:click': [_buyButtonsClick__WEBPACK_IMPORTED_MODULE_1__["default"]],
  pageview: [_pmeCookieCheckout__WEBPACK_IMPORTED_MODULE_0__["default"]],
  'shoppingbag:click': [_pmeCookieCheckout__WEBPACK_IMPORTED_MODULE_0__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 59765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _PmdCartCookie_pmdCookieCheckout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58996);

var pmeCookieCheckout = function pmeCookieCheckout(page) {
  var config = {
    cookieShowcaseName: 'pme_showcase_name',
    partnerId: 67633,
    prefix: 'parceiro'
  };
  (0,_PmdCartCookie_pmdCookieCheckout__WEBPACK_IMPORTED_MODULE_0__["default"])(page, config);
};
/* harmony default export */ __webpack_exports__["default"] = (pmeCookieCheckout);

/***/ }),

/***/ 89923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var CategoryPageView = function CategoryPageView(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var structure = _ref.structure;
  var siteId = structure == null ? void 0 : structure.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  var CategoryData = structure == null ? void 0 : structure.route;
  window.rtbhEvents = window.rtbhEvents || [];
  if (siteId === 'category') {
    var _window;
    return (_window = window) == null ? void 0 : _window.rtbhEvents.push({
      eventType: 'category',
      categoryId: CategoryData.categoryId
    }, {
      eventType: 'uid',
      id: customerId !== null && customerId !== void 0 ? customerId : 'unknown'
    });
  }
  if (siteId === 'subcategory') {
    var _window2;
    return (_window2 = window) == null ? void 0 : _window2.rtbhEvents.push({
      eventType: 'category',
      categoryId: CategoryData.subCategoryId
    }, {
      eventType: 'uid',
      id: customerId !== null && customerId !== void 0 ? customerId : 'unknown'
    });
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (CategoryPageView);

/***/ }),

/***/ 71238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var HomePageView = function HomePageView(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var structure = _ref.structure;
  var siteId = structure == null ? void 0 : structure.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  window.rtbhEvents = window.rtbhEvents || [];
  if (siteId === 'home') {
    var _window;
    (_window = window) == null ? void 0 : _window.rtbhEvents.push({
      eventType: 'home'
    }, {
      eventType: 'uid',
      id: customerId !== null && customerId !== void 0 ? customerId : 'unknown'
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (HomePageView);

/***/ }),

/***/ 64054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var addToCart = function addToCart(_ref) {
  var _window;
  var clientId = _ref.clientId,
    product = _ref.product;
  var id = product.id;
  window.rtbhEvents = window.rtbhEvents || [];
  (_window = window) == null ? void 0 : _window.rtbhEvents.push({
    eventType: 'basketadd',
    offerId: id
  }, {
    eventType: 'uid',
    id: clientId || 'unknown'
  });
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 23018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _pdpClickWishlist__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50448);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64054);
/* harmony import */ var _HomePageView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71238);
/* harmony import */ var _CategoryPageView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89923);
/* harmony import */ var _promotionalPageView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56355);
/* harmony import */ var _pdpPageView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9063);
/* harmony import */ var _placebo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96913);
/* harmony import */ var _searchPageView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41654);








var events = {
  'addtocart:success': [_addToCart__WEBPACK_IMPORTED_MODULE_0__["default"]],
  pageview: [_HomePageView__WEBPACK_IMPORTED_MODULE_1__["default"], _CategoryPageView__WEBPACK_IMPORTED_MODULE_2__["default"], _promotionalPageView__WEBPACK_IMPORTED_MODULE_3__["default"], _searchPageView__WEBPACK_IMPORTED_MODULE_4__["default"], _pdpPageView__WEBPACK_IMPORTED_MODULE_5__["default"], _placebo__WEBPACK_IMPORTED_MODULE_6__["default"]],
  'product:wishlist:click': [_pdpClickWishlist__WEBPACK_IMPORTED_MODULE_7__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 50448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var pdpClickWishlist = function pdpClickWishlist(_ref) {
  var _structure$cookies, _structure$cookies$ac, _window;
  var structure = _ref.structure,
    id = _ref.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  var productId = id;
  window.rtbhEvents = window.rtbhEvents || [];
  (_window = window) == null ? void 0 : _window.rtbhEvents.push({
    eventType: 'wishlist',
    offerId: productId
  }, {
    eventType: 'uid',
    id: customerId !== null && customerId !== void 0 ? customerId : 'unknown'
  });
};
/* harmony default export */ __webpack_exports__["default"] = (pdpClickWishlist);

/***/ }),

/***/ 9063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var pdpPageView = function pdpPageView(_ref) {
  var _structure$cookies, _structure$cookies$ac, _data$product;
  var data = _ref.data,
    structure = _ref.structure;
  var siteId = structure == null ? void 0 : structure.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  var productId = data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.id;
  window.rtbhEvents = window.rtbhEvents || [];
  if (siteId === 'product') {
    var _window;
    (_window = window) == null ? void 0 : _window.rtbhEvents.push({
      eventType: 'offer',
      offerId: productId
    }, {
      eventType: 'uid',
      id: customerId !== null && customerId !== void 0 ? customerId : 'unknown'
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (pdpPageView);

/***/ }),

/***/ 96913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var Placebo = function Placebo(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var structure = _ref.structure;
  var PAGES = ['bigsale', 'category', 'product', 'home', 'search', 'selection', 'subcategory'];
  var siteId = structure == null ? void 0 : structure.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  window.rtbhEvents = window.rtbhEvents || [];
  if (!PAGES.includes(siteId)) {
    var _window;
    (_window = window) == null ? void 0 : _window.rtbhEvents.push({
      eventType: 'placebo'
    }, {
      eventType: 'uid',
      id: customerId !== null && customerId !== void 0 ? customerId : 'unknown'
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Placebo);

/***/ }),

/***/ 56355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var promotionalPageView = function promotionalPageView(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var structure = _ref.structure;
  var siteId = structure == null ? void 0 : structure.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  window.rtbhEvents = window.rtbhEvents || [];
  if (siteId === 'bigsale' || siteId === 'selection') {
    var _window;
    (_window = window) == null ? void 0 : _window.rtbhEvents.push({
      eventType: 'sales'
    }, {
      eventType: 'uid',
      id: customerId !== null && customerId !== void 0 ? customerId : 'unknown'
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (promotionalPageView);

/***/ }),

/***/ 41654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var searchPageView = function searchPageView(_ref) {
  var _structure$cookies, _structure$cookies$ac, _data$search, _data$search$products;
  var data = _ref.data,
    structure = _ref.structure;
  var siteId = structure == null ? void 0 : structure.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  var productList = data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$products = _data$search.products) == null ? void 0 : _data$search$products.slice(0, 5);
  var productListIds = productList == null ? void 0 : productList.map(function (product) {
    return product.id;
  });
  window.rtbhEvents = window.rtbhEvents || [];
  if (siteId === 'search') {
    var _window;
    (_window = window) == null ? void 0 : _window.rtbhEvents.push({
      eventType: 'listing',
      offerIds: productListIds
    }, {
      eventType: 'uid',
      id: customerId !== null && customerId !== void 0 ? customerId : 'unknown'
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (searchPageView);

/***/ }),

/***/ 40789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23018);


/***/ }),

/***/ 88935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var PageView = function PageView(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var structure = _ref.structure;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  if (typeof window.spdt === 'function') {
    window.spdt('alias', {
      id: customerId
    });
    window.spdt('view');
  }
};
/* harmony default export */ __webpack_exports__["default"] = (PageView);

/***/ }),

/***/ 71850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var callSpdt = function callSpdt(data) {
  if (typeof window.spdt === 'function') {
    var _data$product, _data$product2, _data$product3, _data$product3$catego, _data$product4, _data$product4$seller, _data$product5, _data$product5$price;
    window.spdt('product', {
      currency: 'BRL',
      product_id: data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.id,
      product_name: data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : _data$product2.title,
      product_type: data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : (_data$product3$catego = _data$product3.category) == null ? void 0 : _data$product3$catego.id,
      product_vendor: data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : (_data$product4$seller = _data$product4.seller) == null ? void 0 : _data$product4$seller.id,
      value: data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : (_data$product5$price = _data$product5.price) == null ? void 0 : _data$product5$price.bestPrice
    });
  }
};
var ProductView = function ProductView(_ref) {
  var data = _ref.data,
    structure = _ref.structure;
  if ((structure == null ? void 0 : structure.id) === 'product') {
    callSpdt(data);
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (ProductView);

/***/ }),

/***/ 53085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var addToCart = function addToCart(_ref) {
  var _window, _product$category, _product$seller, _product$price;
  var product = _ref.product;
  (_window = window) == null ? void 0 : _window.spdt == null ? void 0 : _window.spdt('addtocart', {
    currency: 'BRL',
    product_id: product == null ? void 0 : product.id,
    product_name: product == null ? void 0 : product.title,
    product_type: product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.id,
    product_vendor: product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : _product$seller.category,
    quantity: 1,
    value: product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.bestPrice
  });
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 80273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var addToWishList = function addToWishList(_ref) {
  var _window;
  var id = _ref.id,
    price = _ref.price;
  (_window = window) == null ? void 0 : _window.spdt == null ? void 0 : _window.spdt('lead', {
    category: 'Add to Wish List',
    currency: 'BRL',
    type: id,
    value: price == null ? void 0 : price.bestPrice
  });
};
/* harmony default export */ __webpack_exports__["default"] = (addToWishList);

/***/ }),

/***/ 94554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _PageView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88935);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53085);
/* harmony import */ var _addToWishList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80273);
/* harmony import */ var _ProductView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71850);




var events = {
  'addtocart:success': [_addToCart__WEBPACK_IMPORTED_MODULE_0__["default"]],
  pageview: [_PageView__WEBPACK_IMPORTED_MODULE_1__["default"], _ProductView__WEBPACK_IMPORTED_MODULE_2__["default"]],
  'product:wishlist:click': [_addToWishList__WEBPACK_IMPORTED_MODULE_3__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 7223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94554);


/***/ }),

/***/ 89206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _newsletterSuccess__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59577);
/* harmony import */ var _pageView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92901);
/* harmony import */ var _productDetail__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53388);
/* harmony import */ var _productAddCart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28061);
/* harmony import */ var _productListClick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19399);





var Stewie = {
  'addtocart:success': [_productAddCart__WEBPACK_IMPORTED_MODULE_0__["default"]],
  'newsletter:success': [_newsletterSuccess__WEBPACK_IMPORTED_MODULE_1__["default"]],
  pageview: [_pageView__WEBPACK_IMPORTED_MODULE_2__["default"], _productDetail__WEBPACK_IMPORTED_MODULE_3__["default"]],
  'product:quickClickSelectItem': [_productListClick__WEBPACK_IMPORTED_MODULE_4__["default"]],
  'productlist:click': [_productListClick__WEBPACK_IMPORTED_MODULE_4__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (Stewie);

/***/ }),

/***/ 59577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var NewsletterSuccess = function NewsletterSuccess() {
  var _structure$cookies, _structure$cookies$ac, _structure$cookies2, _window, _window$stewie;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref.structure;
  var accountId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id;
  var customerId = structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.customerId;
  if ((_window = window) == null ? void 0 : (_window$stewie = _window.stewie) == null ? void 0 : _window$stewie.api) {
    var userId = accountId || customerId;
    stewie.api.uid(userId);
    stewie.api.sendUserInformation({
      origin: data == null ? void 0 : data.origin,
      userInformation: data == null ? void 0 : data.email,
      userName: data == null ? void 0 : data.name
    });
    stewie.api.dispatch();
  }
};
/* harmony default export */ __webpack_exports__["default"] = (NewsletterSuccess);

/***/ }),

/***/ 92901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var pageView = function pageView() {
  var _structure$cookies, _structure$cookies$ac, _structure$cookies2, _structure$config, _window, _window$stewie;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    structure = _ref.structure;
  var accountId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id;
  var customerId = structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.customerId;
  var salesChannelId = (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.salesChannelId) || '';
  var shouldPing = !customerId || accountId && customerId !== accountId;
  if (((_window = window) == null ? void 0 : (_window$stewie = _window.stewie) == null ? void 0 : _window$stewie.api) && shouldPing) {
    stewie.api.channel(salesChannelId);
    if (accountId) {
      stewie.api.uid(accountId);
    }
    stewie.api.ping();
    stewie.api.dispatch();
  }
};
/* harmony default export */ __webpack_exports__["default"] = (pageView);

/***/ }),

/***/ 28061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildProductEvent": function() { return /* binding */ buildProductEvent; }
/* harmony export */ });
var buildProductEvent = function buildProductEvent() {
  var _product$price, _product$price2, _product$seller;
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    price: product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.fullPrice,
    productCashPrice: product == null ? void 0 : (_product$price2 = product.price) == null ? void 0 : _product$price2.bestPrice,
    productId: product == null ? void 0 : product.variationId,
    sellerId: product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : _product$seller.id
  };
};
var productAddCart = function productAddCart() {
  var _window, _window$stewie;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product,
    _ref$channel = _ref.channel,
    channel = _ref$channel === void 0 ? '' : _ref$channel;
  if ((_window = window) == null ? void 0 : (_window$stewie = _window.stewie) == null ? void 0 : _window$stewie.api) {
    stewie.api.channel(channel);
    stewie.api.cart([buildProductEvent(product)]);
    stewie.api.dispatch();
  }
};
/* harmony default export */ __webpack_exports__["default"] = (productAddCart);

/***/ }),

/***/ 53388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildProductEvent": function() { return /* binding */ buildProductEvent; }
/* harmony export */ });
var buildProductEvent = function buildProductEvent() {
  var _product$price, _product$installment;
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    productCashPrice: product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.bestPrice,
    productId: product == null ? void 0 : product.variationId,
    productPrice: product == null ? void 0 : (_product$installment = product.installment) == null ? void 0 : _product$installment.totalAmount
  };
};
var productDetail = function productDetail() {
  var _window, _window$stewie;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$structure = _ref.structure,
    structure = _ref$structure === void 0 ? {} : _ref$structure,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data;
  var pageName = structure.name;
  var product = data.product;
  if (((_window = window) == null ? void 0 : (_window$stewie = _window.stewie) == null ? void 0 : _window$stewie.api) && pageName === 'produto') {
    var _structure$config;
    stewie.api.view(buildProductEvent(product));
    stewie.api.channel((structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.salesChannelId) || '');
    stewie.api.dispatch();
  }
};
/* harmony default export */ __webpack_exports__["default"] = (productDetail);

/***/ }),

/***/ 19399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76854);

var productListClick = function productListClick() {
  var _window, _window$stewie;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref.structure;
  if (((_window = window) == null ? void 0 : (_window$stewie = _window.stewie) == null ? void 0 : _window$stewie.api) && data.origin === 'doory') {
    var _structure$cookies, _structure$config, _data$category;
    stewie.api.uid(structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.customerId);
    stewie.api.channel((structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.salesChannelId) || '');
    stewie.api.clickedOnSearch({
      departmentId: data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id,
      productId: data == null ? void 0 : data.id
    });
    stewie.api.dispatch();
  }
  if (data.origin === 'bob' && data.trackingUrl) {
    var _data$trackingUrl$spl = data.trackingUrl.split('?'),
      _data$trackingUrl$spl2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_data$trackingUrl$spl, 1),
      trackingUrl = _data$trackingUrl$spl2[0];
    document.createElement('img').src = trackingUrl;
  }
};
/* harmony default export */ __webpack_exports__["default"] = (productListClick);

/***/ }),

/***/ 11887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_buildProduct__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79583);

var addToCart = function addToCart() {
  var _window, _window$ttq;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    product = _ref.product;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventId = _ref2.eventId;
  if (((_window = window) == null ? void 0 : (_window$ttq = _window.ttq) == null ? void 0 : _window$ttq.track) && product) {
    window.ttq.track('AddToCart', (0,_utils_buildProduct__WEBPACK_IMPORTED_MODULE_0__["default"])(product), {
      event_id: eventId
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 17695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11887);
/* harmony import */ var _viewItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91268);


var events = {
  'product:addToCart': [_addToCart__WEBPACK_IMPORTED_MODULE_0__["default"]],
  'product:details': [_viewItem__WEBPACK_IMPORTED_MODULE_1__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 91268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_buildProduct__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79583);

var viewItem = function viewItem() {
  var _window, _window$ttq;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    product = _ref.product;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventId = _ref2.eventId;
  if (!((_window = window) == null ? void 0 : (_window$ttq = _window.ttq) == null ? void 0 : _window$ttq.track)) return;
  window.ttq.track('ViewContent', (0,_utils_buildProduct__WEBPACK_IMPORTED_MODULE_0__["default"])(product), {
    event_id: eventId
  });
};
/* harmony default export */ __webpack_exports__["default"] = (viewItem);

/***/ }),

/***/ 41535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17695);


/***/ }),

/***/ 79583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var buildProduct = function buildProduct(product) {
  var _product$price, _product$price2, _product$category, _product$subcategory;
  var productPrice = Number((product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.bestPrice) || (product == null ? void 0 : (_product$price2 = product.price) == null ? void 0 : _product$price2.price));
  return {
    content_type: 'product',
    contents: [{
      content_category: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.id), " - ").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(product == null ? void 0 : (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.id)),
      content_id: product == null ? void 0 : product.variationId,
      content_name: product == null ? void 0 : product.title,
      price: productPrice,
      quantity: 1
    }],
    currency: 'BRL',
    value: productPrice
  };
};
/* harmony default export */ __webpack_exports__["default"] = (buildProduct);

/***/ }),

/***/ 52898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AllIn": function() { return /* reexport safe */ _AllIn__WEBPACK_IMPORTED_MODULE_0__["default"]; },
/* harmony export */   "Bing": function() { return /* reexport safe */ _Bing__WEBPACK_IMPORTED_MODULE_15__["default"]; },
/* harmony export */   "CloudRetail": function() { return /* reexport safe */ _CloudRetail__WEBPACK_IMPORTED_MODULE_14__["default"]; },
/* harmony export */   "Cookies": function() { return /* reexport safe */ _Cookies__WEBPACK_IMPORTED_MODULE_2__["default"]; },
/* harmony export */   "Criteo": function() { return /* reexport safe */ _Criteo__WEBPACK_IMPORTED_MODULE_1__["default"]; },
/* harmony export */   "GA": function() { return /* reexport safe */ _GA__WEBPACK_IMPORTED_MODULE_3__["default"]; },
/* harmony export */   "GA4": function() { return /* reexport safe */ _GA4__WEBPACK_IMPORTED_MODULE_4__["default"]; },
/* harmony export */   "Kwai": function() { return /* reexport safe */ _Kwai__WEBPACK_IMPORTED_MODULE_5__["default"]; },
/* harmony export */   "MiniAppSdk": function() { return /* reexport safe */ _MiniAppSdk__WEBPACK_IMPORTED_MODULE_11__["default"]; },
/* harmony export */   "PmdActions": function() { return /* reexport safe */ _PmdActions__WEBPACK_IMPORTED_MODULE_8__["default"]; },
/* harmony export */   "PmdCartCookie": function() { return /* reexport safe */ _PmdCartCookie__WEBPACK_IMPORTED_MODULE_9__["default"]; },
/* harmony export */   "PmeCartCookie": function() { return /* reexport safe */ _PmeCartCookie__WEBPACK_IMPORTED_MODULE_10__["default"]; },
/* harmony export */   "RTBHouse": function() { return /* reexport safe */ _RTBHouse__WEBPACK_IMPORTED_MODULE_12__["default"]; },
/* harmony export */   "SpotifyAdAnalytics": function() { return /* reexport safe */ _SpotifyAdAnalytics__WEBPACK_IMPORTED_MODULE_13__["default"]; },
/* harmony export */   "Stewie": function() { return /* reexport safe */ _Stewie__WEBPACK_IMPORTED_MODULE_6__["default"]; },
/* harmony export */   "TikTok": function() { return /* reexport safe */ _TikTok__WEBPACK_IMPORTED_MODULE_7__["default"]; },
/* harmony export */   "inventory": function() { return /* binding */ inventory; }
/* harmony export */ });
/* harmony import */ var _AllIn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73778);
/* harmony import */ var _Criteo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79381);
/* harmony import */ var _Cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30040);
/* harmony import */ var _GA__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19487);
/* harmony import */ var _GA4__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57016);
/* harmony import */ var _Kwai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40649);
/* harmony import */ var _Stewie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89206);
/* harmony import */ var _TikTok__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41535);
/* harmony import */ var _PmdActions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41234);
/* harmony import */ var _PmdCartCookie__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86823);
/* harmony import */ var _PmeCartCookie__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58579);
/* harmony import */ var _MiniAppSdk__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10379);
/* harmony import */ var _RTBHouse__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40789);
/* harmony import */ var _SpotifyAdAnalytics__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7223);
/* harmony import */ var _CloudRetail__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80542);
/* harmony import */ var _Bing__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10482);
















var inventory = ['AllIn', 'Criteo', 'Cookies', 'GA', 'GA4', 'Stewie', 'PmdActions', 'PmdCartCookie', 'PmeCartCookie', 'SpotifyAdAnalytics', 'TikTok', 'Kwai', 'MiniAppSdk', 'RTBHouse', 'CloudRetail', 'Bing'];

/***/ })

}]);